exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Button__websiteUsersMainFilterSection-module___mREz- {\n  border-top-right-radius: 0.375rem;\n  border-bottom-right-radius: 0.375rem;\n  border-top-left-radius: unset;\n  border-bottom-left-radius: unset;\n  border-color: #dee2e6;\n  background-color: #eef2f7;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// Exports
exports.locals = {
	"Button": "Button__websiteUsersMainFilterSection-module___mREz-"
};